function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#FF8200"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 10.667a2 2 0 100 4 2 2 0 000-4zm5.333-2h-1.6a.594.594 0 01-.526-.38l-.414-1.241a.594.594 0 00-.526-.38H9.733a.593.593 0 00-.526.38l-.414 1.241a.594.594 0 01-.526.38h-1.6c-.734 0-1.334.6-1.334 1.333v6c0 .733.6 1.333 1.334 1.333h10.666c.734 0 1.334-.6 1.334-1.333v-6c0-.733-.6-1.333-1.334-1.333zM12 16a3.333 3.333 0 110-6.667A3.333 3.333 0 0112 16zm4.867-5.068a.467.467 0 110-.933.467.467 0 010 .933z",
  fill: "#fff"
});

var _ref4 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 12,
  cy: 140,
  r: 12,
  fill: "#FF8200"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.333 139.627a.334.334 0 01-.097.236l-.667.667a.333.333 0 01-.472 0l-.43-.431-.431.431a.334.334 0 01-.471 0l-.667-.667a.33.33 0 01-.098-.236v-6.133l-1.753.479a.333.333 0 00-.247.321v11.333c0 .151.1.282.246.322l7.087 1.933v-15.843l-2 .546v7.042zm.903 4.57a.334.334 0 01-.472 0l-.43-.431v1.195a.334.334 0 01-.667.001v-1.195l-.431.43a.334.334 0 01-.471-.471l.999-.999a.335.335 0 01.363-.073.314.314 0 01.109.073l1 .999c.13.13.13.34 0 .471zm6.097-4.236a4.3 4.3 0 012.476.782.333.333 0 00.524-.272v-6.177a.33.33 0 00-.246-.321L12 132.04v12.255a4.338 4.338 0 014.333-4.334zm0 .666a3.67 3.67 0 00-3.666 3.667 3.67 3.67 0 003.666 3.667A3.67 3.67 0 0020 144.294a3.672 3.672 0 00-3.667-3.667zm1.334 4h-1v1a.334.334 0 01-.667 0v-1h-1a.333.333 0 110-.666h1v-1a.334.334 0 11.667 0v1h1a.333.333 0 110 .666z",
  fill: "#fff"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.8,
  stroke: "#FF8200",
  strokeWidth: 0.5,
  d: "M11.75 60V28m0 96V92"
});

var _ref7 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 12,
  cy: 76,
  r: 12,
  fill: "#FF8200"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.333 80a1.333 1.333 0 001.334-1.333v-6a1.333 1.333 0 00-1.334-1.334h-3.06a.666.666 0 01-.466-.193l-.947-.947a.667.667 0 00-.467-.193H6a1.334 1.334 0 00-1.333 1.333v7.334A1.333 1.333 0 006 80h9.333zM9 72a1 1 0 110 2 1 1 0 010-2zm6.333 6.333a.333.333 0 01-.333.334H6.333A.333.333 0 016 78.333v-.226c0-.074.026-.145.073-.2L8 75.46a.348.348 0 01.233-.127.334.334 0 01.26.12l.967 1.167a.328.328 0 00.402.084.34.34 0 00.118-.097l1.92-2.48a.34.34 0 01.533 0l2.834 3.78a.34.34 0 01.066.2v.226zM18 74v6a1.333 1.333 0 01-1.333 1.333H7.333a1.333 1.333 0 001.334 1.334h8A2.667 2.667 0 0019.333 80v-4.667A1.333 1.333 0 0018 74z",
  fill: "#fff"
});

var SvgIntroStepVertImg = function SvgIntroStepVertImg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 152,
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIntroStepVertImg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/intro-step-vert-img.45a0dac0.svg";
export { ForwardRef as ReactComponent };